// Функція для транслітерації кирилиці в латиницю
const transliterate = str => {
  const mapping = {
    а: "a",
    б: "b",
    в: "b",
    д: "d",
    е: "e",
    з: "z",
    і: "i",
    к: "k",
    л: "l",
    м: "m",
    н: "h",
    о: "o",
    р: "p",
    с: "c",
    т: "t",
    у: "y",
    ф: "f",
    х: "x",
    ю: "u",
    я: "ya",
    А: "A",
    Б: "B",
    В: "B",
    Д: "D",
    Е: "E",
    З: "Z",
    І: "I",
    К: "K",
    Л: "L",
    М: "M",
    Н: "H",
    О: "O",
    Р: "P",
    С: "C",
    Т: "T",
    У: "Y",
    Ф: "F",
    Х: "X",
    Ю: "U",
    Я: "Ya",
  };

  return str
    .split("")
    .map(char => mapping[char] || char)
    .join("");
};

export const validateSearchTerm = (term, setInputError, setSearchTerm) => {
  const plateTerm = transliterate(term);
  const autoTerm = term;

  if (/^[a-zA-Z0-9]*$/.test(plateTerm) && /^[a-zA-Z0-9]*$/.test(autoTerm)) {
    setSearchTerm(plateTerm);
    setInputError("");
  } else {
    setInputError("Вводьте лише латинські літери та цифри");
  }
};

// export const filterCarsBySearchTerm = (cars, searchTerm) => {
//   if (!searchTerm) return cars;

//   const lowerCaseSearchTerm = searchTerm.toLowerCase();
//   return cars.filter((car) => {
//     const plateValue = car.plate ? transliterate(car.plate).toLowerCase() : "";
//     const autoValue = car.auto ? car.auto.toLowerCase() : "";
//     return (
//       plateValue.includes(lowerCaseSearchTerm) ||
//       autoValue.includes(lowerCaseSearchTerm)
//     );
//   });
// };

export const filterCarsBySearchTerm = (cars, searchTerm) => {
  if (!searchTerm) return cars;

  const lowerSearchTerm = searchTerm.toLowerCase();
  const transliteratedSearch = transliterate(lowerSearchTerm);

  return cars.filter(car => {
    const plateValue = car?.vehicle?.plate
      ? transliterate(car.vehicle.plate).toLowerCase()
      : "";
    // const modelValue = car.vehicle.model ? car.vehicle.model.toLowerCase() : "";
    // const makeValue = car.vehicle.make ? car.vehicle.make.toLowerCase() : "";

    return plateValue.includes(transliteratedSearch);
    // modelValue.includes(lowerSearchTerm) ||
    // makeValue.includes(lowerSearchTerm)
  });
};

// функція для пошуку в Зверненях тільки по назві авто з полем car_name

// Оновлена функція для пошуку в Зверненнях по назві авто та імені користувача
export const filterBySearchConnections = (connections, searchTerm) => {
  if (!searchTerm) return connections;

  const lowerCaseSearchTerm = searchTerm.toLowerCase();

  return connections.filter(connection => {
    const carName = connection.car_name
      ? connection.car_name.toLowerCase()
      : "";
    const userName = connection.customer_name
      ? connection.customer_name.toLowerCase()
      : "";
    return (
      carName.includes(lowerCaseSearchTerm) ||
      userName.includes(lowerCaseSearchTerm)
    );
  });
};

// функція для пошуку в Клієнти в роботі  тільки по назві авто з полем make + model + plate

export const filterBySearchClientsInWork = (cars, searchTerm) => {
  if (!searchTerm) return cars;

  const lowerCaseSearchTerm = searchTerm.toLowerCase();
  const searchPlate = transliterate(lowerCaseSearchTerm);

  return cars.filter(car => {
    const make = car.vehicle?.make?.toLowerCase() || "";
    const model = car.vehicle?.model?.toLowerCase() || "";
    const plate = car.vehicle?.plate
      ? transliterate(car.vehicle?.plate).toLowerCase()
      : "";
    const clientName = car.customer?.first_name?.toLowerCase() || "";

    const clientLastName = car.customer?.last_name?.toLowerCase() || "";

    const clientCompany = car.customer?.company_name?.toLowerCase() || "";

    return (
      make.includes(lowerCaseSearchTerm) ||
      model.includes(lowerCaseSearchTerm) ||
      plate.includes(searchPlate) ||
      clientName.includes(lowerCaseSearchTerm) ||
      clientLastName.includes(lowerCaseSearchTerm) ||
      clientCompany.includes(lowerCaseSearchTerm)
    );
  });
};
